interface Props {
  facebookUrl: string;
}

const FOUNDING_TOTAL = 50;
const FOUNDING_CLAIMED = 23;

export default function FoundingMemberBanner({ facebookUrl }: Props) {
  const spotsLeft = FOUNDING_TOTAL - FOUNDING_CLAIMED;
  const pct = Math.round((FOUNDING_CLAIMED / FOUNDING_TOTAL) * 100);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-3xl overflow-hidden border-2 border-amber-200 bg-gradient-to-br from-amber-50 to-orange-50 p-10 text-center">
          {/* Crown icon */}
          <div className="w-16 h-16 flex items-center justify-center bg-amber-100 rounded-2xl mx-auto mb-6">
            <i className="ri-award-fill text-amber-500 text-3xl"></i>
          </div>

          <div className="inline-flex items-center gap-2 bg-amber-500 text-white text-xs font-bold px-4 py-1.5 rounded-full mb-5">
            <i className="ri-time-line text-xs"></i>
            Only {spotsLeft} of {FOUNDING_TOTAL} Founding spots left
          </div>

          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3 leading-snug">
            Become a <span className="text-amber-500">Founding Member</span>
          </h2>

          <p className="text-gray-600 text-base leading-relaxed mb-4 max-w-lg mx-auto">
            Limited to the first 50 VIP members. Get permanent recognition, a special Founding Member badge,
            and a bonus perk — a free event invite or exclusive merch. First come, first locked in.
          </p>

          <p className="text-sm font-bold text-amber-700 mb-6">
            &ldquo;If you&apos;re already coming to events, this just makes your life easier.&rdquo;
          </p>

          {/* Progress bar */}
          <div className="max-w-xs mx-auto mb-8">
            <div className="flex items-center justify-between mb-2">
              <span className="text-xs text-gray-500 font-semibold">{FOUNDING_CLAIMED} claimed</span>
              <span className="text-xs text-amber-600 font-bold">{spotsLeft} left</span>
            </div>
            <div className="h-2.5 bg-amber-100 rounded-full overflow-hidden">
              <div
                className="h-full bg-amber-500 rounded-full transition-all"
                style={{ width: `${pct}%` }}
              />
            </div>
            <p className="text-xs text-gray-400 mt-1.5 text-center">{pct}% claimed · closes at 50</p>
          </div>

          {/* Perks list */}
          <div className="flex flex-wrap items-center justify-center gap-3 mb-8">
            {[
              'Founding Member badge',
              'Free event invite',
              'First access to everything',
              'Permanent recognition',
            ].map((perk) => (
              <span key={perk} className="flex items-center gap-1.5 text-xs font-semibold text-amber-800 bg-amber-100 px-3 py-1.5 rounded-full">
                <i className="ri-check-line text-amber-600 text-xs"></i>
                {perk}
              </span>
            ))}
          </div>

          <a
            href={facebookUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-9 py-4 bg-amber-500 hover:bg-amber-600 text-white text-sm font-bold rounded-full transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-vip-crown-fill"></i>
            Claim Your Founding Spot
          </a>

          <p className="text-xs text-gray-400 mt-3">VIP required · $12/mo or $120/year</p>
        </div>
      </div>
    </section>
  );
}
